import commonViewJs from '../common/commonView.js'
import commonJs from '../common/common.js'
import Store from '../store/store'
const commonBlendingJs = {}

/**
 * 多台正投时判断第一台投影仪的位置(平面多台)
 * w 每台屏幕的宽
 * h 每台屏幕的高
 */
commonBlendingJs.getFirstMultiplePosi = function (h, v, dis, flag) {
  let initScreen = commonViewJs.blendingGetInitScreenXyFromDist(dis)
  let x = 0
  let z = 0
  if (flag) {
    x = h / 2 + initScreen.calY * Store.state.blendingParam.vLensShiftNow / 100
    z = v / 2
  } else {
    x = h / 2
    z = v / 2 + initScreen.calY * Store.state.blendingParam.vLensShiftNow / 100
  }
  return {
    x: x,
    z: z
  }
}
/**
 * 获取每一台投影仪的坐标(平面多台)
 * hCount 列 2
 * vCount 行 1
 * h 每台屏幕的宽 432
 * v 每台屏幕的高 270
 * hCoverRate h重合率 0.45
 * vCoverRate v重合率 0
 */
commonBlendingJs.getInitMultiplePosi = function (hCount, vCount, h, v, hCoverRate, vCoverRate, dis) {
  let flag = commonViewJs.blendingIsReAspactRatio()
  let points = []
  let f = this.getFirstMultiplePosi(h, v, dis, flag)
  let angle = commonJs.getInclinationAngle(h / 2 / dis) * 2
  let initScreen = commonViewJs.blendingGetInitScreenXyFromDist(dis)
  let initAngle = commonJs.getInclinationAngle(initScreen.calX / 2 / dis) * 2
  f.y = dis
  if (flag) {
    initAngle = commonJs.getInclinationAngle(initScreen.calY / 2 / dis) * 2
    f.vLensShift = 0
    f.hLensShift = -Store.state.blendingParam.vLensShiftNow
  } else {
    f.vLensShift = Store.state.blendingParam.vLensShiftNow
    f.hLensShift = 0
  }
  f.angle = angle
  f.initAngle = initAngle
  f.w = h
  f.h = v
  points.push(f)
  let disH = h - h * hCoverRate
  let disV = v - v * vCoverRate
  for (let i = 0; i < vCount; i++) {
    for (let j = 0; j < hCount; j++) {
      if (i === 0 && j === 0) {
        continue
      } else {
        let p = {}
        p.x = f.x + disH * j
        p.z = f.z + disV * i
        p.w = h
        p.h = v
        p.y = dis
        if (flag) {
          p.vLensShift = 0
          p.hLensShift = -Store.state.blendingParam.vLensShiftNow
        } else {
          p.vLensShift = Store.state.blendingParam.vLensShiftNow
          p.hLensShift = 0
        }
        p.angle = angle
        p.initAngle = initAngle
        points.push(p)
      }
    }
  }
  return points
}

/**
 * 通过屏幕坐标，获取投影仪可移动范围坐标(平面多台)
 */
commonBlendingJs.getAvagePointsByScreen = function (sc, wi, hi, disMin) {
  let flag = commonViewJs.blendingIsReAspactRatio()
  let initScreen = commonViewJs.blendingGetInitScreenXyFromDist(disMin)
  let w = initScreen.calX
  let h = initScreen.calY
  let lensShiftData = Store.state.blendingParam.seLensData.lcd.lensShiftRange
  let vMin = lensShiftData.v.min
  let vMax = lensShiftData.v.max
  let hMin = lensShiftData.h.min
  let hMax = lensShiftData.h.max
  let hvMax = isNaN(lensShiftData.hv.max) ? 0 : lensShiftData.hv.max
  let hvMin = isNaN(lensShiftData.hv.min) ? 0 : lensShiftData.hv.min

  // let vMin = Store.state.blendingParam.vLensShift.min
  // let vMax = Store.state.blendingParam.vLensShift.max
  // let hMin = Store.state.blendingParam.hLensShift.min
  // let hMax = Store.state.blendingParam.hLensShift.max
  // let hvMax = isNaN(Store.state.blendingParam.vhLensShift.max) ? 0 : Store.state.blendingParam.vhLensShift.max
  // let hvMin = isNaN(Store.state.blendingParam.vhLensShift.min) ? 0 : Store.state.blendingParam.vhLensShift.min

  let isCeilingUstLens = Store.state.blendingParam.position === '1' && (vMin > 0)

  let points = []
  let c = {}
  c.x = sc.x + wi / 2
  c.y = sc.z + hi / 2
  if (!flag) {
    let val = 0
    if (vMin > 0) {
      val = vMin
    }
    if (vMax < 0) {
      val = vMax
    }
    if (isCeilingUstLens) {
      val = -vMin
      vMin = -vMin
      vMax = -vMax
    }
    let p0 = {}
    // 上顶点
    p0.x = c.x
    p0.y = c.y + h * vMin
    points.push(p0)
    // 左顶点
    let p3 = {}
    p3.x = c.x + w * hMax
    p3.y = c.y + h * (hvMin + val)
    points.push(p3)
    let p2 = {}
    p2.x = c.x + w * hMax
    p2.y = c.y + h * (hvMax + val)
    points.push(p2)
    // 下顶点
    let p1 = {}
    p1.x = c.x
    p1.y = c.y + h * vMax
    points.push(p1)
    // 右顶点
    let p5 = {}
    p5.x = c.x + w * hMin
    p5.y = c.y + h * (hvMax + val)
    points.push(p5)

    let p4 = {}
    p4.x = c.x + w * hMin
    p4.y = c.y + h * (hvMin + val)
    points.push(p4)
  } else {
    w = initScreen.calY
    h = initScreen.calX
    let val = 0
    if (vMin > 0) {
      val = vMin
    }
    if (vMax < 0) {
      val = vMax
    }
    if (isCeilingUstLens) {
      val = -vMin
      vMin = -vMin
      vMax = -vMax
    }
    let p0 = {}
    // 左顶点
    p0.x = c.x + w * vMin
    p0.y = c.y
    points.push(p0)

    // 下顶点
    let p3 = {}
    p3.x = c.x + w * (hvMin + val)
    p3.y = c.y + h * hMax
    points.push(p3)
    let p2 = {}
    p2.x = c.x + w * (hvMax + val)
    p2.y = c.y + h * hMax
    points.push(p2)
    // 右顶点
    let p1 = {}
    p1.x = c.x + w * vMax
    p1.y = c.y
    points.push(p1)
    // 上顶点
    let p5 = {}
    p5.x = c.x + w * (hvMax + val)
    p5.y = c.y + h * hMin
    points.push(p5)
    let p4 = {}
    p4.x = c.x + w * (hvMin + val)
    p4.y = c.y + h * hMin
    points.push(p4)
  }
  return points
}

/**
 * 平面多台时，计算投影仪组合(平面多台)
 * wt 总屏幕的宽 25000
 * ht 总屏幕的高 5000
 * mixRateMin 混合比最小 0.15
 * mixRateMax 混合比最大 0.45
 * hMax 横向最大台数 20
 * vMax 纵向最大台数 3 (ver2.3 取消此限制)
 * ratio 单台屏幕比例 4:3
 */
commonBlendingJs.getMultipleComb = function (wt, ht, mixRateMin, mixRateMax, hMax, vMax, ratio, perPjScreenSizeRange) {
  // 单台屏幕的宽高
  let w = 0
  let h = 0
  let comb = []
  let screen = null
  let wCount = 0
  let hCount = 0
  let mixRate = 0
  let co = 0
  let co2 = 0
  let mixh = 0
  let mixv = 0
  for (let j = 1; j < hMax + 1; j++) {
    if (j === 1) {
      w = wt
      mixv = 0
      screen = commonViewJs.getScreenSizeByCalX(w, ratio)
      h = screen.calY
      hCount = Math.ceil(ht / h)
      mixRate = (ht - hCount * h) / (h - hCount * h)
      co2 = this.getMultipleCombRitwt(mixRateMin, mixRate, mixRateMax, hCount, vMax, ht, screen, j, w, mixv)
      if (co2.v) {
        comb.push(co2)
      }
    } else {
      // 多行时 中间量
      if (mixRateMin < 0.25) {
        mixv = 0.25
        w = wt / (j - j * mixv + mixv)
        screen = commonViewJs.getScreenSizeByCalX(w, ratio)
        h = screen.calY
        hCount = Math.ceil(ht / h)
        mixRate = (ht - hCount * h) / (h - hCount * h)
        co2 = this.getMultipleCombRitwt(mixRateMin, mixRate, mixRateMax, hCount, vMax, ht, screen, j, w, mixv)
        if (co2.v) {
          comb.push(co2)
        }
      }
      // 最小值
      w = wt / (j - j * mixRateMin + mixRateMin)
      screen = commonViewJs.getScreenSizeByCalX(w, ratio)
      h = screen.calY
      hCount = Math.ceil(ht / h)
      mixRate = (ht - hCount * h) / (h - hCount * h)
      mixv = mixRateMin
      co2 = this.getMultipleCombRitwt(mixRateMin, mixRate, mixRateMax, hCount, vMax, ht, screen, j, w, mixv)
      if (co2.v) {
        comb.push(co2)
      }
      // 最大值
      w = wt / (j - j * mixRateMax + mixRateMax)
      screen = commonViewJs.getScreenSizeByCalX(w, ratio)
      h = screen.calY
      hCount = Math.ceil(ht / h)
      mixRate = (ht - hCount * h) / (h - hCount * h)
      mixv = mixRateMax
      co2 = this.getMultipleCombRitwt(mixRateMin, mixRate, mixRateMax, hCount, vMax, ht, screen, j, w, mixv)
      if (co2.v) {
        comb.push(co2)
      }
    }
  }

  for (let i = 1; i < vMax + 1; i++) {
    if (i === 1) {
      // 单行时
      mixh = 0
      // ステップ 1：スクリーン高さに合わせたプロジェクターサイズの決定スクリーンの高さ（例：3m）を基準に、プロジェクターの縦サイズを固定。
      h = ht
      // -- アスペクト比（例：16:10）を用いて、横サイズを算出： 横幅=高さ×16/10=4.8m
      screen = commonViewJs.getScreenSizeByCalY(h, ratio)
      w = screen.calX

      // =============================================================================================
      // オーバーシュート 的场合,符合条件的组合
      // 設定された条件に基づき、希望するスクリーンサイズに対して各プロジェクターの投影サイズが一致しないように計算
      // =============================================================================================
      co = this.getMultipleOvershoot(w, mixRateMin, mixRateMax, hMax, wt, ht, ratio, mixh)
      if (co.length > 0) {
        comb = comb.concat(co)
      }

      // =============================================================================================
      // 設定された条件に基づき、希望するスクリーンサイズに対して各プロジェクターの投影サイズが正確に一致するように計算
      // =============================================================================================
      wCount = Math.ceil(wt / w)
      mixRate = (wt - wCount * w) / (w - wCount * w)
      co = this.getMultipleCombRitht(mixRateMin, mixRate, mixRateMax, wCount, hMax, wt, screen, i, h, mixh)
      if (co.h) {
        comb.push(co)
      }
    } else {
      // 多行时 中间量
      if (mixRateMin < 0.25) {
        mixh = 0.25
        h = ht / (i - i * mixh + mixh)
        screen = commonViewJs.getScreenSizeByCalY(h, ratio)
        w = screen.calX
        wCount = Math.ceil(wt / w)
        mixRate = (wt - wCount * w) / (w - wCount * w)
        co = this.getMultipleCombRitht(mixRateMin, mixRate, mixRateMax, wCount, hMax, wt, screen, i, h, mixh)
        if (co.h) {
          comb.push(co)
        }
      }
      // 最小值
      h = ht / (i - i * mixRateMin + mixRateMin)
      screen = commonViewJs.getScreenSizeByCalY(h, ratio)
      w = screen.calX
      wCount = Math.ceil(wt / w)
      mixRate = (wt - wCount * w) / (w - wCount * w)
      mixh = mixRateMin
      co = this.getMultipleCombRitht(mixRateMin, mixRate, mixRateMax, wCount, hMax, wt, screen, i, h, mixh)
      if (co.h) {
        comb.push(co)
      }
      // 最大值
      h = ht / (i - i * mixRateMax + mixRateMax)
      screen = commonViewJs.getScreenSizeByCalY(h, ratio)
      w = screen.calX
      wCount = Math.ceil(wt / w)
      mixRate = (wt - wCount * w) / (w - wCount * w)
      mixh = mixRateMax
      co = this.getMultipleCombRitht(mixRateMin, mixRate, mixRateMax, wCount, hMax, wt, screen, i, h, mixh)
      if (co.h) {
        comb.push(co)
      }
    }
  }

  let result = this.checkScreenSizeRange(perPjScreenSizeRange, comb, ratio)
  .sort((a,b)=>a.total-b.total)
  return result
}

/**
 * オーバーシュート 的场合，符合条件的组合(平面多台)
 * 設定された条件に基づき、希望するスクリーンサイズに対して各プロジェクターの投影サイズが一致しないように計算
 */
commonBlendingJs.getMultipleOvershoot = function (w, mixRateMin, mixRateMax, hMax, wt, ht, ratio, mixh) {
  // ステップ 2：このサイズでスクリーンをカバーするための台数を予測
  // -- 最小ブレンディング率（例：15%）を考慮した「有効横幅」を計算： 有効横幅=4.8×(1−0.15)=4.08m
  let effectiveW = w * (1 - mixRateMin)
  // -- スクリーン幅（例：20m）をこの有効横幅で割って、必要な台数を算出： 必要台数=⌈20/4.08⌉=5台
  let wCount = Math.ceil(wt / effectiveW)

  // ステップ 3：最大台数構成のブレンディング率を計算
  // -- 実際に5台並べたときの合計投影幅：5×4.8=24.0m
  // -- スクリーン幅（例：20m）との差分（重なり部分）： 24.0−20.0=4.0m
  // -- 1台あたりの重なり率： 4.0/（(5−1)×4.8）×100=20.83%
  let blendingRate = (wCount * w - wt) / ((wCount -1) * w)

  let result = []
  // ステップ 4：条件に合えば構成を記録
  // -- この重なり率が設定範囲（例：15〜45%）に収まっていれば、構成を保存。
  if (mixRateMin > blendingRate || blendingRate > mixRateMax) {
    wCount = wCount - 1
  }

  // ステップ 5：台数を1つ減らして再試行
  // -- 今度は、最小ブレンディング率（例：15%）を固定して、
  // -- スクリーン幅（例：20m）をカバーするために必要な「1台あたりの横幅」を逆算： 横幅=20/（n−(n−1)×0.15）
  // ​-- この横幅から、アスペクト比を使って高さを再計算： 高さ=横幅×10/16
  for (let j = 2; j <= wCount; j++) {
    let horizontalWidth = wt / (j - (j - 1) * mixRateMin)
    let screen = commonViewJs.getScreenSizeByCalX(horizontalWidth, ratio)
    let height = screen.calY
    // ステップ 6：再度ブレンディング率をチェック
    // -- 今回はブレンディング率が15％固定なので、計算不要。
    // -- 条件に合えば構成を保存。
    if (j <= hMax && height >= ht) {
      result.push({
        h: j, // 台数(水平)
        v: 1, // 台数(垂直)
        total: j,
        mixRateH: mixRateMin, // ブレンディング量(水平)
        mixRateV: mixh,       // ブレンディング量(垂直)
        size: screen.size,    // 单台屏幕的Size (inch)
        screenW: horizontalWidth,     // 单台投影仪在屏幕上的宽度
        screenH: height,              // 单台投影仪在屏幕上的高度
        disMin: commonViewJs.calScreensizeToDistanceBlendingWide(screen.size), // 投写距離min
        disMax: commonViewJs.calScreensizeToDistanceBlendingTele(screen.size) // 投写距離max
        // projectionW: horizontalWidth, // 单台投影的宽度
        // projectionH: height,          // 单台投影的高度
      })
    }
  }
  return result
}

/**
 * 根据参数获取当行数固定时，满足条件的列数(平面多台)
 */
commonBlendingJs.getMultipleCombRitht = function (mixRateMin, mixRate, mixRateMax, wCount, hMax, wt, screen, i, h, mixh) {
  let isFlag = false
  for (let j = 1; j < 6; j++) {
    if (mixRateMin <= mixRate && mixRate <= mixRateMax && wCount <= hMax) {
      isFlag = true
    }
    wCount = mixRate < mixRateMin ? wCount + 1 : ((mixRate >= mixRateMin && mixRate <= mixRateMax) ? wCount : (mixRate > mixRateMax ? wCount - 1 : wCount))
    mixRate = (wt - wCount * screen.calX) / (screen.calX - wCount * screen.calX)
  }
  let c1 = {}
  if (isFlag) {
    c1.h = wCount // 台数(水平)
    c1.v = i      // 台数(垂直)
    c1.total = wCount * i
    c1.mixRateH = mixRate   // ブレンディング量(水平)
    c1.mixRateV = mixh      // ブレンディング量(垂直)
    c1.size = screen.size   // 单台屏幕的Size (inch)
    c1.screenW = screen.calX  // 单台屏幕的宽度
    c1.screenH = h            // 单台屏幕的高度
    c1.disMin = commonViewJs.calScreensizeToDistanceBlendingWide(screen.size) // 投写距離min
    c1.disMax = commonViewJs.calScreensizeToDistanceBlendingTele(screen.size) // 投写距離max
  }
  return c1
}

/**
 * 根据参数获取当列数固定时，满足条件的行数(平面多台)
 */

//  (mixRateMin, mixRate, mixRateMax, hCount, vMax, ht, screen, j, w, mixv)
commonBlendingJs.getMultipleCombRitwt = function (mixRateMin, mixRate, mixRateMax, hCount, vMax, ht, screen, i, w, mixv) {
  let isFlag = false
  for (let j = 1; j < 6; j++) {
    if (mixRateMin <= mixRate && mixRate <= mixRateMax && hCount <= vMax) {
      isFlag = true
    }
    hCount = mixRate < mixRateMin ? hCount + 1 : ((mixRate >= mixRateMin && mixRate <= mixRateMax) ? hCount : (mixRate > mixRateMax ? hCount - 1 : hCount))
    mixRate = (ht - hCount * screen.calY) / (screen.calY - hCount * screen.calY)
  }

  let c1 = {}
  if (isFlag) {
    c1.h = i
    c1.v = hCount
    c1.total = hCount * i
    c1.mixRateH = mixv
    c1.mixRateV = mixRate
    c1.size = screen.size
    c1.screenW = w
    c1.screenH = screen.calY
    c1.disMin = commonViewJs.calScreensizeToDistanceBlendingWide(screen.size)
    c1.disMax = commonViewJs.calScreensizeToDistanceBlendingTele(screen.size)
  }
  return c1
}

/**
 * 获取平面多台时重合部分的大小(平面多台)
 * blendingH 横向重合比
 * h 单个屏幕的宽
 * blendingV 纵向重合比
 * v 单个屏幕的高
 */
commonBlendingJs.getMultipleCoverDis = function (blendingH, h, blendingV, v) {
  let res = {}
  res.coverH = blendingH * h
  res.coverV = blendingV * v
  return res
}

/**
 * 多台曲面时，投影仪各个点的坐标及角度（曲面多台凹凸面）
 * radius 半径10
 * arcLengthPer 每台的弧长5.676
 * mixRate 混合比0.18908116694978894
 * proCount 投影仪台数 10
 * distanceMin 最小距离 4.353
 * atFlag 凹面凸面标识 0标识凹面，1标识凸面
 */
commonBlendingJs.getCurvedMultiplePoints = function (radius, arcLengthPer, mixRate, proCount, distanceMin, atFlag, angle) {
  let scAngle = (commonJs.getDegreesByRadian(Store.state.blendingParam.angle)).toFixed(2)
  let initScreen = commonViewJs.blendingGetInitScreenXyFromDist(distanceMin)
  let archLen = commonJs.getDepthByRadiusChord(radius, initScreen.calX)
  let initAngle = commonJs.getInclinationAngle(initScreen.calX / 2 / (distanceMin - archLen)) * 2
  if (Number(scAngle) === 360) {
    // 求从屏幕描绘基准到第一台的角度
    let angleP0 = 0
    let disPro = 360 / proCount
    let points = []
    for (let i = 1; i < proCount + 1; i++) {
      let p = {}
      p.angle = angle
      p.projectAngle = angleP0 + (disPro * (i - 1))
      p.initAngle = initAngle
      if (atFlag === '0') {
        p.x = (radius - distanceMin) * Math.cos(commonJs.getRadianByDegrees(p.projectAngle))
        p.y = (radius - distanceMin) * Math.sin(commonJs.getRadianByDegrees(p.projectAngle))
      } else {
        p.x = (radius + distanceMin) * Math.cos(commonJs.getRadianByDegrees(p.projectAngle))
        p.y = (radius + distanceMin) * Math.sin(commonJs.getRadianByDegrees(p.projectAngle))
      }
      points.push(p)
    }
    return points
    // return
  } else {
    let pi = Math.PI

    // 求从屏幕描绘基准到第一台的角度 16.3
    let angleP0 = ((arcLengthPer / 2) / (2 * pi * radius)) * 360

    // 求第2台以后的投影仪的间隔 26.4
    let disPro = ((1 - mixRate) / (2 * pi * radius)) * arcLengthPer * 360

    let points = []
    let reAngle = 0
    let extraAngle = atFlag === '1' ? 180 : 0
    if (Number(scAngle) < 180 && atFlag === '0') {
      reAngle = (180 - Number(scAngle)) / 2 + extraAngle
    } else if (atFlag === '1') {
      reAngle = (180 - Number(scAngle)) / 2 + extraAngle
    }
    for (let i = 1; i < proCount + 1; i++) {
      let p = {}
      p.projectAngle = angleP0 + (disPro * (i - 1)) + reAngle
      // p.projectAngle = angleP0 + (disPro * (i - 1)) + 45
      p.angle = angle
      p.initAngle = initAngle
      if (atFlag === '0') {
        p.x = (radius - distanceMin) * Math.cos(commonJs.getRadianByDegrees(p.projectAngle))
        p.y = (radius - distanceMin) * Math.sin(commonJs.getRadianByDegrees(p.projectAngle))
      } else if (atFlag === '1') {
        p.x = (radius + distanceMin) * Math.cos(commonJs.getRadianByDegrees(p.projectAngle))
        p.y = (radius + distanceMin) * Math.sin(commonJs.getRadianByDegrees(p.projectAngle))
      }
      // commonJs.calculateRotate(p, 45)
      points.push(p)
    }
    return points
  }
}

/**
 * 多台曲面时，投影仪排列组合凹面（曲面多台凹面）
 * screenH 屏幕高3.5
 * radius 半径10
 * arcLengthTol 总弧长24.4
 * angle 每个弧的角度
 * angleTol 总中心角140
 * deep 屏幕深度6.56
 * mixWidthMin 混合宽度15%
 * mixWidthMax 混合宽度45%
 * ratio 比例 16:10
 * disMin最小距离
 * disMax最大距离
 * projectorsNumberMax 输入投影仪的最大数量
 */
commonBlendingJs.getCurvedMultipleCombAo = function (screenH, radius, angle, mixWidthMin, mixWidthMax, ratio, disMin, disMax, perPjScreenSizeRange, projectorsNumberMax) {
  let pi = Math.PI
  // 获取单台屏幕宽
  let screen = commonViewJs.getScreenSizeByCalY(screenH, ratio)
  let screenW = screen.calX
  let archLen = commonJs.getDepthByRadiusChord(radius, screenW)
  // 投影仪宽的度数
  let hScAngle = commonJs.getInclinationAngle(screenW / 2 / (disMin - archLen)) * 2
  let arcLengthTol = 2 * radius * pi * (angle / 360)
  // 获取单台投影仪的弧长
  let arcLengthPer = radius * (2 * Math.asin(screenW / (2 * radius)))
  let num = Math.ceil(arcLengthTol / arcLengthPer)
  // 获取单台投影仪的屏幕深度
  let deep = radius - (radius * Math.sin((pi - (arcLengthPer / radius)) / 2))
  let res = []

  // =============================================================================================
  // オーバーシュート 的场合,符合条件的组合
  // =============================================================================================
  let overshoot = this.getCurvedMultipleOvershootAo(screenW, screenH, arcLengthPer, arcLengthTol, mixWidthMin, mixWidthMax, radius, ratio, projectorsNumberMax, angle)
  if (overshoot.length > 0) {
    res = res.concat(overshoot)
  }

  // 混合比
  let percent = 0
  let i = num - 1
  if (Number(angle) === 360) {
    i = num
    // mixRate = (num - (arcLengthTol / arcLengthPer)) / (num - 1)
    percent = 1 - (2 * radius * pi) / (i * arcLengthPer)
    while (percent > mixWidthMax || percent < mixWidthMin) {
      if (percent > mixWidthMax) {
        i--
      } else {
        i++
      }
      percent = 1 - (2 * radius * pi) / (i * arcLengthPer)
    }
    let r = {}
    r.total = i
    r.mixRateH = percent
    r.size = screen.size
    r.screenW = screenW
    r.screenH = screenH
    r.arcLen = arcLengthPer
    r.disMin = disMin
    r.disMax = disMax
    r.angle = hScAngle
    r.deep = deep
    if (projectorsNumberMax && i <= projectorsNumberMax) {
      res.push(r)
    }
  } else {
    while (percent <= mixWidthMax) {
      if (percent >= mixWidthMin) {
        let r = {}
        r.total = i
        r.mixRateH = percent
        r.size = screen.size
        r.screenW = screenW
        r.screenH = screenH
        r.arcLen = arcLengthPer
        r.disMin = disMin
        r.disMax = disMax
        r.angle = hScAngle
        r.deep = deep
        if (projectorsNumberMax && i > projectorsNumberMax) {
          break
        }
        res.push(r)
      }
      i++
      percent = (i - (arcLengthTol / arcLengthPer)) / (i - 1)
    }
  }
  let result = this.checkScreenSizeRange(perPjScreenSizeRange, res, ratio)
  return result
}
/**
 * オーバーシュート 的场合，符合条件的组合（曲面多台凹面）
 * 設定された条件に基づき、希望するスクリーンサイズに対して各プロジェクターの投影サイズが一致しないように計算
 */
commonBlendingJs.getCurvedMultipleOvershootAo = function (screenW, screenH, arcLengthPer, arcLengthTol, mixWidthMin, mixWidthMax, radius, ratio, projectorsNumberMax, angle) {
  let pi = Math.PI
  // ステップ 2：有効横幅で必要台数を予測
  // -- 最小ブレンディング率（例：15%）を考慮した「有効横幅」を計算： 有効横幅=4.8×(1−0.15)=4.08m
  let effectiveW = screenW * (1 - mixWidthMin)
  let effectiveArcLengthPer = radius * (2 * Math.asin(effectiveW / (2 * radius)))
  // -- スクリーン横幅（例：20m）をこの有効弧长で割って、必要な台数を算出： 必要台数=⌈20/4.08⌉=5台
  let arcNum = Math.ceil(arcLengthTol / effectiveArcLengthPer)

  // ステップ 3：最大台数構成のブレンディング率を計算
  // -- 実際に5台並べたときの合計投影幅：5×4.8=24.0m
  // -- スクリーン幅（例：20m）との差分（重なり部分）： 24.0−20.0=4.0m
  // -- 1台あたりの重なり率： 4.0/（(5−1)×4.8）×100=20.83%
  let blendingRate = (arcNum * arcLengthPer - arcLengthTol) / ((arcNum -1) * arcLengthPer)
  // let percent1 = (arcNum - (arcLengthTol / arcLengthPer)) / (arcNum - 1)
  if (Number(angle) === 360) {
    blendingRate = 1 - (2 * radius * pi) / (arcNum * arcLengthPer)
  }

  let result = []
  // ステップ 4：条件に合えば構成を記録
  // -- この重なり率が設定範囲（例：15〜45%）に収まっていれば、構成を保存。
  if (mixWidthMin > blendingRate || blendingRate > mixWidthMax) {
    arcNum = arcNum - 1
  }

  // ステップ 5：台数を1つ減らして再試行
  // -- 今度は、最小ブレンディング率（例：15%）を固定して、
  // -- スクリーン幅（例：20m）をカバーするために必要な「1台あたりの横幅」を逆算： 横幅=20/（n−(n−1)×0.15）
  // ​-- この横幅から、アスペクト比を使って高さを再計算： 高さ=横幅×10/16
  for (let j = Number(angle) === 360 ? 3 :2; j <= arcNum; j++) {
    let arcLenPer = arcLengthTol / (j - (j - 1) * mixWidthMin)
    if (Number(angle) === 360) {
      arcLenPer = (2 * radius * pi) / (j * (1 - mixWidthMin))
    }
    let width = radius * (2 * Math.sin(arcLenPer / (2 * radius)))
    let screen = commonViewJs.getScreenSizeByCalX(width, ratio)
    let height = screen.calY

    // 投写距离
    let disMin = commonViewJs.calScreensizeToDistanceBlendingWide(screen.size)
    let disMax = commonViewJs.calScreensizeToDistanceBlendingTele(screen.size)

    // 投影仪宽的度数
    let archLen = commonJs.getDepthByRadiusChord(radius, width)
    let hScAngle = commonJs.getInclinationAngle(width / 2 / (disMin - archLen)) * 2
    // 投影角度大于180°时，跳过
    if (hScAngle < 0) { continue }

    // 获取单台投影仪的屏幕深度
    let deep = radius - (radius * Math.sin((pi - (arcLenPer / radius)) / 2))

    // ステップ 6：再度ブレンディング率をチェック
    // -- 今回はブレンディング率が15％固定なので、計算不要。
    // -- 条件に合えば構成を保存。
    if (j <= projectorsNumberMax && height >= screenH) {
      result.push({
        total: j, // 台数
        mixRateH: mixWidthMin, // 混合比
        size: screen.size,
        screenW: width,
        screenH: height,
        arcLen: arcLenPer,
        disMin: disMin,
        disMax: disMax,
        angle: hScAngle,
        deep: deep
      })
    }
  }
  return result
}
/**
 * 多台曲面时，投影仪排列组合凸面（曲面多台凸面）
 * screenArcLength 总弧长24.4
 * angle
 * radius 半径10
 * angleTol 总中心角140
 * deep 屏幕深度6.56
 * mixWidthMin 混合宽度15%
 * mixWidthMax 混合宽度45%
 * screenH 屏幕高3.5
 * h 镜头高2
 * ratio 比例 16:10
 * disMin 投影仪最小距离
 * disMax 投影仪最大距离
 */
commonBlendingJs.getCurvedMultipleCombTu = function (screenH, radius, angle, mixWidthMin, mixWidthMax, ratio, disMin, disMax, perPjScreenSizeRange, projectorsNumberMax) {
  let pi = Math.PI
  let screenArcLength = 2 * radius * pi * (angle / 360)
  // 获取单台屏幕宽
  let screen = commonViewJs.getScreenSizeByCalY(screenH, ratio)
  // 5.600
  let screenW = screen.calX

  let a1apmin = commonBlendingJs.getConvexA1apmin(screenW, disMin, radius)

  let arcLengthPer = radius * (2 * Math.asin(a1apmin / (2 * radius)))
  let hScAngle = commonJs.getInclinationAngle(screenW / 2 / disMin) * 2
  let num = Math.ceil(screenArcLength / arcLengthPer)
  // 混合比
  let percent = 0
  let i = num - 1
  let res = []

  // =============================================================================================
  // オーバーシュート 的场合,符合条件的组合
  // =============================================================================================
  let overshoot = this.getCurvedMultipleOvershootTu(screenW, screenH, arcLengthPer, screenArcLength, mixWidthMin, mixWidthMax, radius, ratio, projectorsNumberMax, angle)
  if (overshoot.length > 0) {
    res = res.concat(overshoot)
  }

  let tangentAngle = (Math.asin(radius / (radius + disMin)) * 2) / (Math.PI / 180)
  if (Math.ceil(tangentAngle) <= Math.ceil(hScAngle)) {
    // 如果角度大于 投影仪位置到圆屏幕切线的夹角，则跳过(3d视图下，圆柱投影仪的角度大于圆屏幕切线的角度，无边缘交点，无法投影)
  } else if (Number(angle) === 360) {
    i = num
    percent = 1 - (2 * radius * pi) / (i * arcLengthPer)
    while (percent > mixWidthMax || percent < mixWidthMin) {
      if (percent > mixWidthMax) {
        i--
      } else {
        i++
      }
      percent = 1 - (2 * radius * pi) / (i * arcLengthPer)
    }
    let r = {}
    r.total = i
    r.mixRateH = percent
    r.size = screen.size
    r.screenW = screenW
    r.screenH = screenH
    r.arcLen = arcLengthPer
    r.disMin = disMin
    r.disMax = disMax
    r.angle = hScAngle
    if (projectorsNumberMax && i <= projectorsNumberMax) {
      res.push(r)
    }
  } else {
    while (percent <= mixWidthMax) {
      if (percent >= mixWidthMin) {
        let r = {}
        r.total = i
        r.mixRateH = percent
        r.size = screen.size
        r.screenW = screenW
        r.screenH = screenH
        r.arcLen = arcLengthPer
        r.disMin = disMin
        r.disMax = disMax
        r.angle = hScAngle
        if (projectorsNumberMax && i > projectorsNumberMax) {
          break
        }
        res.push(r)
      }
      i++
      percent = (i - (screenArcLength / arcLengthPer)) / (i - 1)
      // percent = 1 - (2 * radius * pi) / (i *arcLengthPer)
    }
  }
  let result = this.checkScreenSizeRange(perPjScreenSizeRange, res, ratio)
  return result
}
commonBlendingJs.getConvexA1apmin = function (screenW, disMin, radius) {
  let xc = 0
  // 14.353
  let yc = disMin + radius

  let xs = 0
  let ys = 0
  // 2.8
  let xe = screenW / 2
  // 4.353
  let xep = -xe
  let ye = disMin
  let yep = disMin

  // 4.353
  let a1 = ye - ys
  let a2 = yep - ys

  // -2.8
  let b1 = xs - xe
  // 2.8
  let b2 = xs - xep

  // 0
  let c1 = ((a1 * xs) + (b1 * ys))
  let c2 = ((a2 * xs) + (b2 * ys))

  // 5.176
  let l1 = Math.pow((Math.pow((xe - xs), 2) + Math.pow((ye - ys), 2)), 1 / 2)
  let l2 = Math.pow((Math.pow((xep - xs), 2) + Math.pow((yep - ys), 2)), 1 / 2)

  // 0.541
  let ex1 = (xe - xs) / l1
  // -0.541
  let ex2 = (xep - xs) / l2

  // 0.841
  let ey1 = (ye - ys) / l1
  let ey2 = (yep - ys) / l2

  // -0.841
  let vx1 = -ey1
  let vx2 = -ey2

  let vy1 = ex1
  let vy2 = ex2

  let k1 = -((a1 * xc) + (b1 * yc) + c1) / ((a1 * vx1) + (b1 * vy1))
  let k2 = -((a2 * xc) + (b2 * yc) + c2) / ((a2 * vx2) + (b2 * vy2))

  let xp1 = xc + (k1 * vx1)
  let xp2 = xc + (k2 * vx2)

  // let yp1 = yc + (k1 * vy1)
  // let yp2 = yc + (k2 * vy2)

  // 6.302
  let t1 = Math.sqrt(Math.pow(radius, 2) - Math.pow(k1, 2)) || 0
  let t2 = Math.sqrt(Math.pow(radius, 2) - Math.pow(k2, 2)) || 0

  // let x11 = xp1 + t1 * ex1
  // let x12 = xp2 + t2 * ex2

  // let y11 = yp1 + t1 * ey1
  // let y12 = yp2 + t2 * ey2

  let x21 = xp1 - t1 * ex1
  let x22 = xp2 - t2 * ex2

  // let y21 = yp1 - t1 * ey1
  // let y22 = yp2 - t2 * ey2

  // let b1b1p = x11 - x12
  let a1a1p = x21 - x22

  return a1a1p
}

/**
 * オーバーシュート 的场合，符合条件的组合（曲面多台凸面）
 * 設定された条件に基づき、希望するスクリーンサイズに対して各プロジェクターの投影サイズが一致しないように計算
 */
commonBlendingJs.getCurvedMultipleOvershootTu = function (screenW, screenH, arcLengthPer, screenArcLength, mixWidthMin, mixWidthMax, radius, ratio, projectorsNumberMax, angle) {
  let pi = Math.PI
  // ステップ 2：有効横幅で必要台数を予測
  // -- 最小ブレンディング率（例：15%）を考慮した「有効横幅」を計算： 有効横幅=4.8×(1−0.15)=4.08m
  let effectiveW = screenW * (1 - mixWidthMin)
  let effectiveS = commonViewJs.getScreenSizeByCalX(effectiveW, ratio).size
  let disMin = commonViewJs.calScreensizeToDistanceBlendingWide(effectiveS)
  let a1apmin = commonBlendingJs.getConvexA1apmin(effectiveW, disMin, radius)
  let effectiveArcLengthPer = radius * (2 * Math.asin(a1apmin / (2 * radius)))

  // -- スクリーン横幅（例：20m）をこの有効弧长で割って、必要な台数を算出： 必要台数=⌈20/4.08⌉=5台
  let arcNum = Math.ceil(screenArcLength / effectiveArcLengthPer)

  // ステップ 3：最大台数構成のブレンディング率を計算
  // -- 実際に5台並べたときの合計投影幅：5×4.8=24.0m
  // -- スクリーン幅（例：20m）との差分（重なり部分）： 24.0−20.0=4.0m
  // -- 1台あたりの重なり率： 4.0/（(5−1)×4.8）×100=20.83%
  let blendingRate = (arcNum * arcLengthPer - screenArcLength) / ((arcNum -1) * arcLengthPer)
  // let percent = (arcNum - (screenArcLength / arcLengthPer)) / (arcNum - 1)
  if (Number(angle) === 360) {
    blendingRate = 1 - (2 * radius * pi) / (arcNum * arcLengthPer)
  }
  
  let result = []
  // ステップ 4：条件に合えば構成を記録
  // -- この重なり率が設定範囲（例：15〜45%）に収まっていれば、構成を保存。
  if (mixWidthMin > blendingRate || blendingRate > mixWidthMax) {
    arcNum = arcNum - 1
  }

  // ステップ 5：台数を1つ減らして再試行
  // -- 今度は、最小ブレンディング率（例：15%）を固定して、
  // -- スクリーン幅（例：20m）をカバーするために必要な「1台あたりの横幅」を逆算： 横幅=20/（n−(n−1)×0.15）
  // ​-- この横幅から、アスペクト比を使って高さを再計算： 高さ=横幅×10/16
  for (let j = Number(angle) === 360 ? 3 :2; j <= arcNum; j++) {
    let arcLenPer = screenArcLength / (j - (j - 1) * mixWidthMin)
    if (Number(angle) === 360) {
      arcLenPer = (2 * radius * pi) / (j * (1 - mixWidthMin))
    }
    // 反推计算
    let {width, disMin} = reverseCalculate(radius, arcLenPer, ratio)
    if (width === null) { continue }
    let screen = commonViewJs.getScreenSizeByCalX(width, ratio)
    let height = screen.calY

    // 投写距离
    // let disMin = commonViewJs.calScreensizeToDistanceBlendingWide(screen.size)
    let disMax = commonViewJs.calScreensizeToDistanceBlendingTele(screen.size)

    // 投影仪宽的度数
    let hScAngle = commonJs.getInclinationAngle(width / 2 / disMin) * 2
    // 如果角度大于 投影仪位置到圆屏幕切线的夹角，则跳过 (360度和非360度场合，都适用)
    // if (Number(angle) === 360) {
    let tangentAngle = (Math.asin(radius / (radius + disMin)) * 2) / (Math.PI / 180)
    if (Math.ceil(tangentAngle) <= Math.ceil(hScAngle)) {
      // console.log('tangentAngle', tangentAngle, 'hScAngle', hScAngle)
      continue
    }
    // }

    // ステップ 6：再度ブレンディング率をチェック
    // -- 今回はブレンディング率が15％固定なので、計算不要。
    // -- 条件に合えば構成を保存。
    if (j <= projectorsNumberMax && height >= screenH) {
      result.push({
        total: j, // 台数
        mixRateH: mixWidthMin, // 混合比
        size: screen.size,
        screenW: width,
        screenH: height,
        arcLen: arcLenPer,
        disMin: disMin,
        disMax: disMax,
        angle: hScAngle
      })
    }
  }
  return result
}
commonBlendingJs.checkScreenSizeRange = function (range, arr, ratio) {
  let yMin = commonViewJs.getScreenXYByScreenSize(range.min, ratio).calY.toFixed(1)
  let yMax = commonViewJs.getScreenXYByScreenSize(range.max, ratio).calY.toFixed(1)
  let result = []
  for (let i = 0; i < arr.length; i++) {
    let yVal = commonViewJs.getScreenXYByScreenSize(arr[i].size, ratio).calY.toFixed(1)
    if (Number(yVal) <= Number(yMax) && Number(yVal) >= Number(yMin)) {
      result.push(arr[i])
    }
  }
  return result
}

function reverseCalculate(radius, arcLengthPer, ratio) {
  let a1a1p = 2 * radius * Math.sin(arcLengthPer / (2 * radius))
  let width = a1a1p
  let addLoopCount = 0
  let abortflag = false
  while (width > 0) {
    let screen = commonViewJs.getScreenSizeByCalX(width, ratio)
    let disMin = commonViewJs.calScreensizeToDistanceBlendingWide(screen.size)
    let a1apminTry = commonBlendingJs.getConvexA1apmin(width, disMin, radius)
    if (a1apminTry / (2 * radius) >= 1) {
      return {width: null, disMin: null}
    }
    let arcLengthPerTry = radius * (2 * Math.asin(a1apminTry / (2 * radius)))

    // console.log('arcLengthPer', arcLengthPer, 'arcLengthPerTry', arcLengthPerTry, 'width', width)

    if (abortflag) return {width, disMin}

    let error = arcLengthPerTry - arcLengthPer
    if (error >= 30) {
      width = width - (error) / 2
    } else if (Math.abs(error) < 1e-3) {
      return {width, disMin}
    } else if (error < 0) {
      width = width + 0.001
      addLoopCount++
    } else if (error < 1) {
      if (addLoopCount > 0) {
        abortflag = true
        width = width + 0.001
      }
      width = width - 0.01
    } else if (error < 3) {
      width = width - 0.5
    } else {
      width = width - 1
    }
  }
  return {width: null, disMin: null}
}

export default commonBlendingJs



// WEBPACK FOOTER //
// ./src/common/commonBlending.js